"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDevApi = exports.getEndpoints = exports.apiEndpoints = exports.env = void 0;
const is_defined_1 = require("../util/is-defined");
// variables __DS_ENV__ and endpoints are defined in Webpack config
exports.env = __DS_ENV__;
exports.apiEndpoints = endpoints;
const getEndpoints = (hostname) => {
    const _endpoints = exports.apiEndpoints[hostname];
    const _fallbackEndpoint = exports.apiEndpoints.fallback;
    if ((0, is_defined_1.isValue)(_endpoints)) {
        return _endpoints;
    }
    if (!(0, is_defined_1.isValue)(_fallbackEndpoint)) {
        throw new Error('No fallback endpoints found. See webpack.config.dist.js, webpack.config.dev.js, webpack.config.common.js');
    }
    return _fallbackEndpoint;
};
exports.getEndpoints = getEndpoints;
// True when the app talks to the DEV API — both a local dev server (`npm run dev`) and the
// deployed app.dev.dayswaps.top. `env` cannot answer this: it is 'dev' for any local webpack
// dev server (`npm run stage` included) and 'stage' for the deployed DEV build.
const isDevApi = () => (0, exports.getEndpoints)(window.location.hostname).backend.includes('api.dev.dayswaps.top');
exports.isDevApi = isDevApi;
// languages
const supportedLanguages = [
    {
        label: 'Česky',
        value: 'cs',
    },
    {
        label: 'English',
        value: 'en',
    },
    {
        label: 'Slovensky',
        value: 'sk',
    },
    {
        label: 'українська',
        value: 'uk',
    },
    {
        label: 'Hrvatska',
        value: 'hr',
    },
    {
        label: 'български',
        value: 'bg',
    },
    {
        label: 'Magyar',
        value: 'hu',
    },
    {
        label: 'Română',
        value: 'ro',
    },
    {
        label: 'Español',
        value: 'es',
    },
    {
        label: 'Deutsch',
        value: 'de',
    },
    {
        label: 'Italiano',
        value: 'it',
    },
    {
        label: 'Polski',
        value: 'pl',
    },
    {
        label: 'Português',
        value: 'pt',
    },
    {
        label: 'Français',
        value: 'fr',
    },
    {
        label: 'Русский',
        value: 'ru',
    },
];
exports.default = {
    supportedLanguages,
    env: exports.env,
    // fallback initial location for map
    defaultCoords: { lat: 50.0696529, lng: 14.4050442 },
    // in registration form
    termsConditionsLink: 'https://dayswaps.com/compliance/',
    // google maps etc.
    googleApiKey: 'AIzaSyANDo9XpA5nK8G5dBouSMHlISpThHYDLbA',
    // IP geo location
    estimateLocationUrl: 'https://www.googleapis.com/geolocation/v1/geolocate?key=',
    // reverse geocoding (country from GPS coords)
    estimateCountryUrl: 'https://maps.googleapis.com/maps/api/geocode/json?key=',
    // stipe pricing table
    stripePricingTableId: exports.env === 'prod'
        ? 'prctbl_1RLjjNDWmRMVmYdUbJ2B9u56'
        : 'prctbl_1R9t1DDWmRMVmYdUzzNq2Rbq',
    stipePublishableKey: exports.env === 'prod'
        ? 'pk_live_ArSt5VBkd44s8p9m2hK5XgY4'
        : 'pk_test_hH2eLZboRktLRZHlpDWnwgJx',
};
